"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = require("react");
/**
 * Returns an object containing three separate boolean properties (isMobile, isTablet, and isDesktop)
 * @param {number} tabletWidth
 * @param {number} desktopWidth
 * @param {string} defaultBreakpoint
 */
const useBreakpoints = (defaultBreakpoint, tabletWidth = 768, desktopWidth = 1025) => {
    const defaultBreakpointOptions = ['mobile', 'tablet', 'desktop'];
    const defaultBreakpointIsValid = defaultBreakpointOptions.includes(defaultBreakpoint);
    if (!defaultBreakpointIsValid) {
        throw new Error(`The default breakpoint provided to the useBreakpoints hook, ${defaultBreakpoint}, is not valid. Please try again with one of the following values: ${defaultBreakpointOptions.join(',  ')}.`);
    }
    const defaultBreakpointData = {
        isMobile: defaultBreakpoint === 'mobile',
        isTablet: defaultBreakpoint === 'tablet',
        isDesktop: defaultBreakpoint === 'desktop'
    };
    const [breakpointData, setBreakpointData] = (0, react_1.useState)(defaultBreakpointData);
    const handleWindowSizeChange = () => {
        const windowWidth = window.innerWidth;
        /* The userAgent property is read-only.
        The value returned, contains information about the browser name, version and platform. */
        const userAgent = navigator.userAgent.toLowerCase();
        const isTabletDevice = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent);
        setBreakpointData({
            isMobile: windowWidth < tabletWidth,
            isTablet: windowWidth >= tabletWidth && (windowWidth < desktopWidth || isTabletDevice),
            isDesktop: windowWidth >= desktopWidth && !isTabletDevice
        });
    };
    (0, react_1.useEffect)(() => {
        if (typeof window !== 'undefined') {
            handleWindowSizeChange();
            window.addEventListener('resize', handleWindowSizeChange);
        }
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    return breakpointData;
};
exports.default = useBreakpoints;
//# sourceMappingURL=use-breakpoints.js.map